import React from 'react';
import i18n from 'i18next';
import { Trans } from 'react-i18next';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';

import { Button, ButtonGroup } from 'uikit/buttons';
import { Icon } from 'uikit/icons';
import { Tooltip } from 'uikit/tooltips';
import { Typo } from 'uikit/content';

import styles from '../styles/profileGold.module.scss';

const ProfileGold = ({
  goldCount,
  goldRedeemURL,
  isGoldLimitReached,
  onViewHistoryClick,
}) => (
  <section className={styles.container}>
    <div className={styles.content}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <Icon
            className={styles.icon}
            icon="gold"
            size={32}
          />
          <Typo
            element="span"
            variant="b01"
          >
            <Trans
              components={[
                <Typo
                  className={styles.goldAmount}
                  element="span"
                  variant="d03"
                />,
              ]}
            >
              {i18n.t('you-have-amount-gold', {
                amount: goldCount,
              })}
            </Trans>
          </Typo>
          {isGoldLimitReached && (
            <div className={styles.caution}>
              <Tooltip content={i18n.t('youve-reached-the-annual-gold-limit')}>
                <WarningAmberOutlined sx={{ height: 18, width: 18 }} />
              </Tooltip>
            </div>
          )}
        </div>
        <div className={styles.right}>
          <ButtonGroup>
            <Button
              size="small"
              text={i18n.t('view-history')}
              variant="ghost"
              onClick={onViewHistoryClick}
            />
            {goldRedeemURL && (
              <Button
                color="brand"
                size="small"
                text={i18n.t('redeem-gold')}
                target="_blank"
                to={goldRedeemURL}
                isExternalLink
              />
            )}
          </ButtonGroup>
        </div>
      </div>
    </div>
  </section>
);

export default React.memo(ProfileGold);
